import React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import sanitizeHtml from '@/lib/utils/sanitizeHtml';

import { DeviceUnlockComponent } from "@/store/sagas/types/deviceUnlock";

const FAQRenderer: React.FC<{ component: DeviceUnlockComponent }> = ({ component }) => {
    const [expanded, setExpanded] = React.useState<number | null>(null);

    const handleChange = (index: number) => (_event: unknown, isExpanded: boolean) => {
        setExpanded(isExpanded ? index : null);
    };

    return (
        <div className="w-full max-w-4xl mx-auto mt-16 px-4 mb-16">
            <h2 className="text-5xl font-extrabold text-black mb-12 text-center tracking-tight">
                {component.details.title}
            </h2>
            {component.details.content.section.map((faq, index) => (
                <Accordion
                    key={faq.id || index}
                    expanded={expanded === index}
                    onChange={handleChange(index)}
                    sx={{ boxShadow: 'none', border: 'none', '&::before': { display: 'none' }, m: 0 }}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls={`faq-panel-${index}-content`}
                        id={`faq-panel-${index}-header`}
                        sx={{
                            minHeight: 40,
                            '&.Mui-expanded': { minHeight: 40 },
                            '& .MuiAccordionSummary-content': { margin: 0 },
                            '& .MuiAccordionSummary-content.Mui-expanded': { margin: 0 },
                            py: 0.5
                        }}
                    >
                        <Typography sx={{ fontWeight: 700, color: '#000' }}>
                            {faq.title}
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ p: 2, pt: 0.5 }}>
                        <div className="mt-1 pb-1 text-gray-800 text-base leading-relaxed">
                            <div 
                                className="prose max-w-none"
                                dangerouslySetInnerHTML={{ __html: sanitizeHtml(faq.body || faq.text || '') }}
                            />
                        </div>
                    </AccordionDetails>
                </Accordion>
            ))}
        </div>
    );
};

export default FAQRenderer;